import React from "react";
import logoAnz from "../assets/images/logo-anz.svg";

function Banner() {
  return (
    <nav
      className="navbar banner float-start"
      style={{ backgroundColor: "#004165", borderRadius: 0, paddingBottom: "4px"}}
    >
     
        <div className="container" style={{ display: "inline", paddingLeft: "91px"}}>
          <a
            href="https://www.anz.co.nz/personal/"
            className="logo logo--authored"
            title="ANZ Logo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logoAnz} alt="ANZ logo" />
          </a>
        </div>
    
    </nav>
  );
}

export default Banner;